import styled from 'styled-components';

export const Input = styled.input`
  margin: 10px 8px 10px 3px;
`;

export const Legend = styled.legend`
  font-weight: bold;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  word-break: break-word;
`;

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`;

export const RadioButtonsContainer = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  gap: 16px;
  ${({ spaceBetween }) => (spaceBetween ? `justify-content: space-between;` : '')}
`;
